/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jade_Pearl_Emu_LeadInputs */

const en_jade_pearl_emu_lead = /** @type {(inputs: Jade_Pearl_Emu_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access results`)
};

const de_jade_pearl_emu_lead = /** @type {(inputs: Jade_Pearl_Emu_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse anzeigen`)
};

/**
* | output |
* | --- |
* | "Access results" |
*
* @param {Jade_Pearl_Emu_LeadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const jade_pearl_emu_lead = /** @type {((inputs?: Jade_Pearl_Emu_LeadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jade_Pearl_Emu_LeadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jade_pearl_emu_lead(inputs)
	return de_jade_pearl_emu_lead(inputs)
});